function Name() {
    return (
        <div>
            <h1 className="home-hero hero-text">Reymond Mesuga</h1>
            <h5 className="hero-text">Machine Learning Researcher and Enthusiast</h5>
        </div>
    )
}

export default Name